export enum ReportSpecVersion {
  V0, // pre-panelbank
  Panelbank,
  FirstClassText,
  FirstClassTextConverted,
  AddPanelIds,
  SlateReport,
}
